export const messages = {
  'de-DE': {
    general: {
      relatedTickets: 'Zugehörige Tickets',
      exactMatches: 'Exakte Treffer',
      additionalMatches: 'Zusätzliche AEs',
      additionalMatchesHint:
        '+{additionalMatchesCount} verknüpfte Abrechnungseinheiten unter ‚{additionalMatchesLabel}‘',
      ticketsForBillingUnit: 'Tickets für Abrechnungseinheit',
      ticketId: 'ID',
      all: 'Alle',
      ticketStatus: 'Ticketstatus',
      noTicketsFound: 'Keine Tickets gefunden',
      noAdditionalTicketsFound: 'Keine weiteren Tickets gefunden',
      errorFetchingAdditionalTickets:
        'Fehler beim Laden der Tickets verknüpfter Abrechnungseinheiten',
      errorFetchingTickets: 'Fehler beim Laden der Tickets',
      additionalBillingUnits: 'Weitere AEs',
      none: '-',
    },
    ticketStatus: {
      new: 'Neu',
      open: 'Offen',
      pending: 'Wartend',
      hold: 'Angehalten',
      solved: 'Gelöst',
      closed: 'Geschlossen',
    },
    pagination: {
      page: 'Seite',
      of: 'von',
      tickets: 'Tickets',
    },
    translationMissing: '/',
  },
};
